import {
  API_HOST,
  getHttpPostOptions,
  getHttpGetOptions,
  getHttpPutOptions,
  getHttpDeleteOptions
} from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/collection`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;
const getDeleteEndpoint = (externalReference, programmeExternalReference) =>
  `${getEndpoint()}/${programmeExternalReference}/${externalReference}`;

export const getCreateCollectionRequest = (collection) => [getEndpoint(), getHttpPostOptions(collection)];

export const getViewAllCollectionsRequest = (externalReference) => [
  getSpecificEndpoint(externalReference),
  getHttpGetOptions()
];

export const getUpdateCollectionRequest = (collection) => [getEndpoint(), getHttpPutOptions(collection)];

export const getDeleteCollectionRequest = (externalReference, programmeExternalReference) => [
  getDeleteEndpoint(externalReference, programmeExternalReference),
  getHttpDeleteOptions()
];
